



































import Vue from 'vue';

export default Vue.extend({
  auth: true,
  data: () => ({
    isDownloading: {} as Record<string | number, boolean>,
    documents: {},
    errorResponse: undefined as any,
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
    columns(): any {
      return [
        { value: this.$t('page.download.table.document'), field: 'fileName' },
      ];
    },
  },
  mounted() {
  },
  methods: {
    navigateBackToOverview() {
      this.$router.push('/syna/memberPortal/downloads');
    },
    async populateDocumentList() {
      const response = await this.$service.api.memberDocuments.getGeneralDocumentList();
      return response;
    },
    async downloadFile(entry : any) {
      this.$set(this.isDownloading, entry.id.value!, true);
      try{
        const docId = entry?.id?.value ?? entry?.id;
        const response = await this.$service.api.memberDocuments.downloadGeneralFile(docId);
        this.$service.utils.downloadFile(`${entry.fileName.value}${entry.fileExtension.value}`, response);
      } catch(error: any) {
        this.errorResponse = error;
      }
      this.$set(this.isDownloading, entry.id.value!, false);
    },
  },
});
